// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_A_3","cls2":"MultiPaperNewsStory-cls2_a0e MultiPaperNewsStory-cls1_A_3"};